import { Heart, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "About", href: "#about" },
    { label: "Solutions", href: "#solutions" },
    { label: "Speaking", href: "#speaking" },
    { label: "Shop", href: "#shop" },
    { label: "Contact", href: "#contact" },
  ];

  const businesses = [
    { label: "Rafha Entertainment", href: "https://rafhaentertainment.com" },
    { label: "Choice Mobile Celebrations", href: "https://rafhaentertainment.com/choice-mobile" },
    { label: "OMW Business & Financial", href: "https://www.omwbusiness.com" },
  ];

  return (
    <footer className="bg-accent text-accent-foreground">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <h3 className="font-display text-2xl font-bold text-cream">
                LaVista<span className="text-gold"> Solutions</span>
              </h3>
              <p className="text-xs text-champagne/70 tracking-wide">
                We help you see the path forward
              </p>
            </div>
            <p className="text-champagne/80 text-sm leading-relaxed mb-4">
              Entrepreneur, Speaker, Minister. Building purpose-driven businesses and lives.
            </p>
            <div className="space-y-2 text-sm text-champagne/80">
              <a href="tel:+18772955905" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Phone className="w-4 h-4" />
                (877) 295-5905
              </a>
              <a href="mailto:info@lavistasolutions.com" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Mail className="w-4 h-4" />
                info@lavistasolutions.com
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                Montgomery, AL
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-cream mb-4 uppercase tracking-wider text-sm">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    className="text-champagne/80 hover:text-gold transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Businesses */}
          <div>
            <h4 className="font-semibold text-cream mb-4 uppercase tracking-wider text-sm">
              My Businesses
            </h4>
            <ul className="space-y-2">
              {businesses.map((biz) => (
                <li key={biz.label}>
                  <a 
                    href={biz.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-champagne/80 hover:text-gold transition-colors text-sm"
                  >
                    {biz.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-semibold text-cream mb-4 uppercase tracking-wider text-sm">
              Let's Connect
            </h4>
            <p className="text-champagne/80 text-sm mb-4">
              Ready to work together? Let's build something amazing.
            </p>
            <a 
              href="#booking"
              className="inline-block bg-gold hover:bg-gold/90 text-accent font-semibold px-6 py-2 rounded-full text-sm transition-colors"
            >
              Book Me
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream/10">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <p className="text-champagne/60 text-sm">
                © {currentYear} <span className="text-gold font-semibold">lavistasolutions.com</span> | All Rights Reserved
              </p>
              <p className="text-champagne/40 text-xs mt-1">
                A <span className="text-champagne/60">WAVE Enterprises, LLC</span> Production
              </p>
            </div>
            <div className="flex items-center gap-6 text-sm text-champagne/60">
              <a href="#" className="hover:text-gold transition-colors">Privacy</a>
              <a href="#" className="hover:text-gold transition-colors">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
